import _regeneratorValues from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _createForOfIteratorHelper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Pagination from './Pagination.vue';
import { getMissionInfoSettings } from '@/api/missionInfoSetting';
import Edit from './Edit.vue';
import { missionTypes } from '@/utils/constants';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "handArmFunction", void 0);
    _defineProperty(_this, "missionTypes", missionTypes);
    _defineProperty(_this, "pagination", {
      total: 1000,
      page: 1,
      limit: 7
    });
    _defineProperty(_this, "edit", {
      showDialog: false,
      setting: {}
    });
    _defineProperty(_this, "settings", []);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "tableRowClassName",
    value: function tableRowClassName(row) {
      if (row.isFree === undefined || row.isFree === null || row.isFree === false) {
        return false;
      }
      return true;
    }
  }, {
    key: "created",
    value: function created() {
      this.getList();
    }
  }, {
    key: "onChangeSHow",
    value: function onChangeSHow(showDialog) {
      if (!showDialog) {
        this.getList();
      }
    }
  }, {
    key: "getTypeLabel",
    value: function getTypeLabel(row, column) {
      var missionType = this.missionTypes.find(function (missionType) {
        return row.type === missionType.key;
      });
      if (missionType) {
        return missionType.label;
      } else return '';
    }
  }, {
    key: "handleEdit",
    value: function handleEdit(setting) {
      this.edit = {
        showDialog: true,
        setting: JSON.parse(JSON.stringify(setting))
      };
    }
  }, {
    key: "getList",
    value: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var start, end, settings, newSettings, sequenceArray, _iterator, _step, _loop, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              start = (this.pagination.page - 1) * this.pagination.limit;
              end = this.pagination.page * this.pagination.limit;
              _context2.n = 1;
              return getMissionInfoSettings(start, end, this.handArmFunction);
            case 1:
              settings = _context2.v;
              newSettings = [];
              sequenceArray = Array.from(Array(this.pagination.limit).keys()).map(function (_, i) {
                return start + i + 1;
              });
              _iterator = _createForOfIteratorHelper(sequenceArray);
              _context2.p = 2;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var sequence, schds;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      sequence = _step.value;
                      schds = settings.filter(function (s) {
                        return s.sequence === sequence;
                      });
                      if (schds.length > 0) {
                        newSettings.push(schds[0]);
                      } else {
                        newSettings.push({
                          sequence: sequence,
                          hand_arm_function: _this2.handArmFunction,
                          missions: []
                        });
                      }
                    case 1:
                      return _context.a(2);
                  }
                }, _loop);
              });
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context2.n = 5;
                break;
              }
              return _context2.d(_regeneratorValues(_loop()), 4);
            case 4:
              _context2.n = 3;
              break;
            case 5:
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t = _context2.v;
              _iterator.e(_t);
            case 7:
              _context2.p = 7;
              _iterator.f();
              return _context2.f(7);
            case 8:
              this.settings = newSettings;
            case 9:
              return _context2.a(2);
          }
        }, _callee, this, [[2, 6, 7, 8]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }()
  }, {
    key: "chunkSettings",
    value: function chunkSettings() {
      var size = 7;
      var chunkedArr = [];
      var index = 0;
      while (index < this.settings.length) {
        chunkedArr.push(this.settings.slice(index, size + index));
        index += size;
      }
      return chunkedArr;
    }
  }, {
    key: "handlePagination",
    value: function () {
      var _handlePagination = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(pagination) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.getList();
            case 1:
              return _context3.a(2);
          }
        }, _callee2, this);
      }));
      function handlePagination(_x) {
        return _handlePagination.apply(this, arguments);
      }
      return handlePagination;
    }()
  }]);
}(Vue);
__decorate([Prop({
  required: true
})], default_1.prototype, "handArmFunction", void 0);
__decorate([Watch('edit.showDialog')], default_1.prototype, "onChangeSHow", null);
default_1 = __decorate([Component({
  name: 'SeveritySetting',
  components: {
    Edit: Edit,
    Pagination: Pagination
  }
})], default_1);
export default default_1;